import { render, staticRenderFns } from "./CampagnaContattiSearch.vue?vue&type=template&id=51b37b42&"
import script from "./CampagnaContattiSearch.vue?vue&type=script&lang=ts&"
export * from "./CampagnaContattiSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports